import { useNavigate } from "react-router-dom";
import RMLogo from "@/assets/images/rm-logo-emblem.svg";
import { Typography } from "@/components/atoms";
import { useSiteConfig } from "@/hooks";

export const ClientLogo = () => {
  const navigate = useNavigate();
  const { name, images } = useSiteConfig();
  const logoUrl = images.emblem || RMLogo;

  return (
    <figure className="flex cursor-pointer items-center gap-2" onClick={() => navigate("/client")}>
      <img className="h-8 w-8 flex-shrink-0 object-contain" src={logoUrl} alt={name} />
      <Typography variant="h2">{name}</Typography>
    </figure>
  );
};
